(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scrolling-text-custom"] && !Shopify.designMode) return;
  try {
    
var elements = $('ul.marquee-item-list li').length;
for(var i=0;i < elements; i++){
 $(".marquee-item-list").clone().prependTo( ".marquee-block" );
};
var liEle = [];
var liEle = $(".marquee-item-list li");

  } catch(e) { console.error(e); }
})();
})();
